import * as React from 'react';
import { Grid } from 'react-flexbox-grid';
import { compose, withState, lifecycle } from 'recompose';

import * as storage from '@inqool/uas-web-core/es/utils/storage';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import { MovementOfficers } from '@modules/maps/tabs/MovementOfficers';
import { MovementVehicles } from '@modules/maps/tabs/MovementVehicles';
import { HeatDelicts } from '@modules/maps/tabs/HeatDelicts';
import { HeatEvents } from '@modules/maps/tabs/HeatEvents';
import { LeafletMap } from '@components/map/LeafletMap';
import { withNotifications } from '@components/hoc/withNotifications';
import { getGisToken } from '@components/map/_mapActions';
import { Tabs } from '@components/tabs';
import { Loader } from '@components/loader';

export const mapLabel = 'Mapa';
export const mapPath = '/map';

export const mapUrl = '/metropolis/geoserver/wms';
const style = { minWidth: 175 };

const enhance = compose<{ layers: Array<any>; handleLayers: (layers: Array<any>) => void }, {}>(
  breadcrumbs([{ label: mapLabel }]),
  withState('layers', 'handleLayers', []),
  withState('gisTokenLoaded', 'handleGisTokenLoaded', false),
  withState('gisTokenValid', 'handleGisTokenValid', true),
  withNotifications({ getGisToken }),
  lifecycle<any, any>({
    async componentDidMount() {
      const { handleGisTokenValid, handleGisTokenLoaded, getGisTokenNotify } = this.props;
      let gisToken = await getGisTokenNotify();
      if (gisToken) {
        storage.put('gistoken', gisToken);
        handleGisTokenValid(true);
      } else {
        storage.remove('gistoken');
        handleGisTokenValid(false);
      }
      handleGisTokenLoaded(true);
    }
  })
);

const View: React.SFC<any> = ({ gisTokenLoaded, gisTokenValid, ...props }) => (
  <div>
    <Grid fluid={true}>
      <div style={{ display: 'flex' }} />
      {!gisTokenLoaded && <Loader />}
      <Tabs
        items={
          gisTokenValid
            ? [
                {
                  label: 'Sledování polohy strážníků',
                  style,
                  content: <MovementOfficers {...props} />
                },
                {
                  label: 'Sledování polohy vozidel',
                  style,
                  content: <MovementVehicles {...props} />
                },
                {
                  label: 'Teplotní mapa přestupků',
                  style,
                  content: <HeatDelicts {...props} />
                },
                {
                  label: 'Teplotní mapa událostí',
                  style,
                  content: <HeatEvents {...props} />
                }
              ]
            : [
                {
                  label: 'Přístup odepřen',
                  style,
                  content: (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '61px' }}>
                      <div style={{ color: 'red' }}>Vaše role nemá přístup ke autorizovaným informacím o poloze</div>
                    </div>
                  )
                }
              ]
        }
      />
      <LeafletMap layers={props.layers} />
    </Grid>
  </div>
);

export const Map = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/maps/Map.tsx